import Splide from '@splidejs/splide';
import "./components/item/ItemImageCarousel";
import "./components/item/Carousel";
import "./components/events/events";
import "./components/header/BannerTopView";
import "./components/item/Category_Attribute_Images";
import LazyLoad from "vanilla-lazyload";


/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;
/*
export default {
    mounted() {
     
    }
  }
*/

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
$(document).on('click', 'footer a[href="#cookie-settings"]', function(event) {
    // Verhindert, dass die Seite nach oben springt
    event.preventDefault(); 
    
    // Findet den Button und triggert den nativen JavaScript-Klick
    var vueButton = document.querySelector('.cookie-bar.out button');
    
    if (vueButton) {
        vueButton.click();
    }
    return false;
});


function initSlider(){
    if($('.splide-slider').length > 0){
        $('.splide-slider').each(function(){
            var slidesperpage = $(this).data('slidesperpage');
            new Splide(this, {
                fixedWidth: '230px',
                drag   : 'free',
                gap    : '12px',
                mediaQuery: 'min',
                pagination: false,
                arrows: false,
                breakpoints:{
                    768: {
                        perPage: 3,
                        fixedWidth: false,
                        arrows: true
                    },
                    992: {
                        perPage: slidesperpage
                    }
                }
              }).mount();
        })
        
    }
    console.log($('.splide-slider-cats').length)
    if($('.splide-slider-cats').length > 0){
        $('.splide-slider-cats').each(function(){
            new Splide(this, {
                fixedWidth: '230px',
                drag   : 'free',
                gap    : '12px',
                mediaQuery: 'min',
                pagination: false,
                arrows: false,
                breakpoints:{
                    768: {
                        perPage: 3,
                        fixedWidth: false,
                        arrows: true
                    },
                    1200: {
                        perPage: 4
                    }
                }
              }).mount();
        });
        
    }
    if($('.splide-rezept-slider').length > 0){
        new Splide('.splide-rezept-slider',{
            arrows: false
        }).mount();
    }
    if($('.splide-slider-stepbystep').length > 0){
        new Splide('.splide-slider-stepbystep', {
            fixedWidth: '252px',
            drag   : 'free',
            gap    : '12px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 4,
                    fixedWidth: false,
                    arrows: true,
                },
                992: {
                    destroy: true,
                    gap    : '12px',
                },
            }
          }).mount();
    }
    if($('.splide-slider-rezept-simple').length > 0){
        new Splide('.splide-slider-rezept-simple', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '12px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 4,
                    fixedWidth: false,
                    arrows: true
                }
            }
          }).mount();
    }
    
}

$(document).ready(function(){
  
    const lazyContent = new LazyLoad({
        elements_selector: '.rf-lazy',
        use_native: false,
        threshold: 500 // <-- there you go
    });
    
    

    
})
document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        initSlider(); 
    }
  }
/*
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    $('.owl-widget-home-carousel').owlCarousel({
            loop:true,
            nav:true,
            items: 1
        })
   console.log("DROP")
});*/
$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    console.log("drinn")
    if(!initShopbuilderScripts){
        const ssIntervall = setInterval(function(){
            if($('.splide').length > 0){
                initSlider();
                const lazyContent = new LazyLoad({
                    elements_selector: '.rf-lazy',
                    use_native: false // <-- there you go
                });
                clearInterval(ssIntervall); 
            }
            
        }, 100);
        
        initShopbuilderScripts = true;
    }
    
});

$(document).on( "click", ".video-home-start-stop", function() {
    
    if($(this).hasClass('video-paused')){
        $('.video-home video').trigger('play');
        $(this).find('span').removeClass('evab-video_play').addClass('evab-video_pause');
        
    }else{
        $('.video-home video').trigger('pause');
        $(this).find('span').removeClass('evab-video_pause').addClass('evab-video_play');
        
    }
    $(this).toggleClass('video-paused');
});

$('.video-home video').on('timeupdate', function() {
    var video = this;
    if (!video.duration) return;

    if (video.currentTime >= video.duration - 0.3) {
        var $video = $(video);
        var $container = $video.closest('.video-home');

        if (!$video.is(':visible')) return;

        $container.find('video').each(function() {
            this.currentTime = 0;
            this.pause();
        });

        var $btn = $container.find('.video-home-start-stop');
        $btn.find('span').removeClass('evab-video_pause').addClass('evab-video_play');
        $btn.addClass('video-paused');
    }
});



// when the active dropzone in the shopbuilder changes
/*
$(document).on("shopbuilder.after.activate-container", (event, data) =>
{
    console.log(data?.container );
});*/
setInterval(function(){ 
    //if($(document).width()<768){
        var elem = $('.top-header-usp .active-point');
        $(elem).removeClass('active-point')
        if($(elem).next('li').length>0){
            $(elem).next('li').addClass('active-point');
        }else{
            $('.top-header-usp li').first().addClass('active-point');
        }

    //}
}, 5000);





/*
$.ajax({
    type: "GET",
    url: '/rest/vatcheck/',
    dataType: 'json',
    success: function(response){ console.log(response) }
  });*/

window.setCookie = setCookie;
window.getCookie = getCookie;
window.initSlider = initSlider;
